import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, Button, cls } from '../../packages/components';
import './styles/AAFModalDocumentType.scss';

const AAFModalDocumentType = (props = {}) => {
    const DocumentType = () => {
      return (
        <Row>
          {props.documents.map((m) => {
            return (
              <Row className='modal-row-button-documents'>
                <Column lg={12} key={m.option}>
                  <Button
                    activate
                    type="button"
                    className={cls('focusable', 'modal-button-documents')}
                    onClick= {(e) => props.handleClose(e, props.service(m.value))}                            >
                    {m.option}
                  </Button>
                </Column>
              </Row>
            );
          })}
        </Row>
      );
    };
    const p = {
      alwaysEnabled: true,
      buttonsAlign: 'vertical',
      aafNewStyle: true,
      className: 'aaf-modal',
      showLogo: false,
    };
    return (
      <ModalWrapper {...p}>
        <DocumentType />
      </ModalWrapper>
    );
};

AAFModalDocumentType.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
};

export default withOnClose(AAFModalDocumentType);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalDocumentType.jsx